import React, {useMemo} from 'react';
import ChartLoader from '@/pages/dashboard/_charts/ChartLoader';
import LineChart from '@/pages/dashboard/_charts/LineChart';
import colors from 'tailwindcss/colors';
import {useProjectsContext} from "@/pages/dashboard/ProjectsContext";
import getQuestionActivityChartData from "@/pages/dashboard/_utils/getQuestionActivityChartData";

export default function QuestionsByMonth(props) {
  const {timestamps} = props;
  const {filteredInvitations, isLoadingInvitations} = useProjectsContext();

  if (isLoadingInvitations) {
    return (
      <ChartLoader
        title="Project invitation breakdown"
        subtitle="Over school year"
      />
    );
  }

  const {series, labels} = useMemo(() =>
    getQuestionActivityChartData(filteredInvitations, timestamps), [filteredInvitations, timestamps]);

  return (
    <LineChart
      title="Project invitation breakdown"
      subtitle="Over school year"
      labels={labels}
      series={series}
      colors={[
        colors.neutral['400'],
        colors.emerald['400'],
        colors.yellow['400'],
        colors.red['400']
      ]}
    />
  );
}
